import { TDentalTechInfoContactEditProps, useDentalTechInfoContactEdit } from "./dental-tech-info-contact-edit-logic";
import { Spinner as SpinnerSmall } from "../common/spinner";
import { usa_flag } from "../../images/flags";

export const DentalTechInfoContactEdit = (props: TDentalTechInfoContactEditProps) => {
    const { cancelHandler, errorPhone, refLinkedin, refPhone, saveContact, userInfo, workingState, currWorkingState } = useDentalTechInfoContactEdit(props);
    const isWorking = workingState === "working" || currWorkingState === "working";
    const isError = workingState === "error" || currWorkingState === "error";

    let saveContactInfoButtonContent;

    if (isWorking) {
        saveContactInfoButtonContent = <SpinnerSmall />;
    } else if (isError) {
        saveContactInfoButtonContent = "Try Again";
    } else {
        saveContactInfoButtonContent = "Save Changes";
    }

    return (
        <div className="card border-0 shadow-sm my-3">
            <div className="card-body p-3 p-md-4">
                <div className="row g-3">
                    <div className="col-12">
                        <h6 className="mb-1">Contact Information</h6>
                        <p className="text-muted mb-0 small">Keep this updated so employers can reach you quickly.</p>
                    </div>

                    <div className="col-12">
                        <label htmlFor="tech-contact-phone" className="form-label fw-semibold mb-1">
                            Phone Number *
                        </label>
                        <div className="input-group">
                            <div className="input-group-text bg-light">
                                <img src={usa_flag} alt="usa_flag" className="me-2 me-lg-0" width={20} />
                                <span className="d-none d-md-block d-lg-none">United States</span>
                                <span className="text-muted ms-md-2">+1</span>
                            </div>
                            <input
                                id="tech-contact-phone"
                                type="tel"
                                maxLength={10}
                                className={"form-control" + (errorPhone ? " is-invalid" : "")}
                                ref={refPhone}
                                defaultValue={`${userInfo?.other?.phone}`}
                                placeholder="5551234567"
                                aria-describedby="tech-contact-phone-help"
                                required
                                inputMode="numeric"
                                autoComplete="tel-national"
                                onChange={() => {
                                    refPhone.current.value = refPhone.current.value.replaceAll(/\D/g, "").slice(0, 10);
                                }}
                            />
                            {errorPhone && <div className="invalid-feedback">{errorPhone}</div>}
                        </div>
                        <div className="form-text mt-1">Example: `5551234567`</div>
                    </div>

                    <div className="col-12">
                        <label htmlFor="tech-contact-linkedin" className="form-label fw-semibold mb-1">
                            LinkedIn
                        </label>
                        <div className="input-group">
                            <span className="input-group-text bg-light" id="tech-contact-linkedin-icon">
                                <i className="fab fa-linkedin fa-sm text-info"></i>
                            </span>
                            <input
                                id="tech-contact-linkedin"
                                type="text"
                                className="form-control"
                                ref={refLinkedin}
                                defaultValue={`https://www.linkedin.com/in/${userInfo?.other?.linkedin}`}
                                maxLength={100}
                                placeholder="https://www.linkedin.com/in/your-profile"
                            />
                        </div>
                        <div className="form-text mt-1">You can paste the full URL or just your username.</div>
                    </div>

                    {isError && (
                        <div className="col-12">
                            <div className="alert alert-warning py-2 px-3 mb-0 small" role="alert">
                                <i className="fa-solid fa-circle-exclamation me-2"></i>
                                We could not save your contact info. Please review the fields and try again.
                            </div>
                        </div>
                    )}

                    <div className="col-12">
                        <div className="row g-2">
                            <div className="col-12 col-md-auto">
                                <button className={"btn w-100 px-4 " + (isError ? "btn-warning" : "btn-primary")} onClick={saveContact} disabled={isWorking}>
                                    {saveContactInfoButtonContent}
                                </button>
                            </div>
                            <div className="col-12 col-md-auto">
                                <button className="btn btn-danger w-100 px-4" onClick={cancelHandler} disabled={isWorking}>
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
